(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/related-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/related-page.js');

'use strict';

const {
  useRef,
  useState,
  useEffect
} = React;
const {
  Debug
} = svs.tur.grid;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  PaymentSuccessInfo,
  ButtonPlay,
  CharityCardList,
  CharityThanksContainer
} = svs.lyckoplatsen.components.page_related.react.components;
const {
  useParams
} = ReactRouterDOM;
const Icon = svs.ui.ReactIcon;
const RelatedPage = () => {
  const {
    wagerId,
    charityId
  } = useParams();
  const parsedCharityId = parseInt(charityId, 10);
  const pageRef = useRef(null);
  const [showGuide, setShowGuide] = useState(false);
  useEffect(() => {
    setShowGuide(parsedCharityId != null && svs.core.detect.formfactor.mobile());
  }, [parsedCharityId]);
  const handleScrollTo = () => {
    if (pageRef.current) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const targetPos = pageRef.current.getBoundingClientRect().bottom + window.scrollY - headerHeight;
      window.scrollTo({
        top: targetPos,
        behavior: 'smooth'
      });
    }
  };
  return React.createElement("div", {
    className: "u-flex u-flex-grow-1 bg-lyckoplatsen-500 u-flex-justify-content-center u-flex-column"
  }, React.createElement(Debug, null), svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && wagerId && React.createElement("div", {
    className: "lp-page-realated",
    ref: pageRef
  }, React.createElement(PaymentSuccessInfo, {
    charityId: parsedCharityId
  }), parsedCharityId === -2 && React.createElement("div", {
    className: "align-center padding-top-1"
  }, "Tyv\xE4rr \xE4r din valda organisationen inte l\xE4ngre m\xF6jlig att v\xE4lja. ", React.createElement("br", null), "Du kan v\xE4lja en annan organisation att st\xF6tta."), parsedCharityId < 0 ? React.createElement(CharityCardList, {
    wagerId: wagerId
  }) : React.createElement(CharityThanksContainer, {
    charityId: parsedCharityId
  }), showGuide && React.createElement("div", {
    className: "lp-guide-button align-center padding-bottom-2",
    type: "button",
    onClick: handleScrollTo
  }, React.createElement("p", {
    className: "h4"
  }, "Vad h\xE4nder nu?"), React.createElement(Icon, {
    size: "600",
    icon: "menu-down"
  })), React.createElement(ButtonPlay, null)), React.createElement(WidgetArea, {
    areaName: "relatedWidgetArea",
    widgetArea: "relatedWidgetArea"
  }));
};
setGlobal('svs.lyckoplatsen.components.page_related.react', {
  RelatedPage
});

 })(window);